import HttpClient from '../httpClient';
import UsersService from './usersService';
import ActivitiesService from './activitiesService';
import PhotosService from './photosService';
import LikesService from './likesService';
import CommentsService from './commentsService';
import Entry from '../models/entry';
import templatedUrl from 'url-template';

const EntriesService = {

  parseEntry: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      title: response.title,
      message: response.message,
      createdAt: new Date(response.at),
      user: UsersService.parseUser(response._embedded['dm:user:v1']),
      activities: response._embedded['dm:activities:v1'].map(activityResponse => ActivitiesService.parseActivity(activityResponse)),
      photos: response._embedded['dm:photos:v1'].map(photoResponse => PhotosService.parsePhoto(photoResponse)),
      likes: response._embedded['dm:likes:v1'].map(likeResponse => LikesService.parseLike(likeResponse)),
      comments: response._embedded['dm:comments:v1'].map(commentResponse => CommentsService.parseComment(commentResponse)),
      _links: response._links,
      _forms: response._forms
    };
  },

  parseEntriesList: function(response) {
    if (!response || !response._embedded || !response._embedded.item) return [];

    return response._embedded.item.map(entryResponse => {
      return EntriesService.parseEntry(entryResponse);
    });
  },

  parseStreamPagination: function(response) {
    if (!response || !response._links) return {};

    const { previous, next } = response._links;
    return { streamPreviousUrl: (previous && previous.href), streamNextUrl: (next && next.href) };
  },

  getStreamForCurrentUser: function(currentUser) {
    const streamLink = currentUser.getLink('dm:home_entries:v1');
    let url = streamLink.href;
    if (streamLink.templated) {
      url = templatedUrl.parse(url).expand({ per_page: 20 });
    }
    return this.fetchStreamFromUrl(url);
  },

  fetchStreamFromUrl: function(url) {
    return HttpClient.get(url).then(response => {
      const streamPagination = EntriesService.parseStreamPagination(response);
      const entries = EntriesService.parseEntriesList(response).map(entryProps => new Entry(entryProps));
      return { pagination: streamPagination, entries };
    });
  }

};

export default EntriesService;



// WEBPACK FOOTER //
// ./src/api/services/entriesService.js